import { GA_PREFIXES, getDomain } from '@/lib/utils'

const date = new Date()
date.setFullYear(date.getFullYear() + 100)

export const removeGACookies = () => {
  const cookies = document.cookie
  cookies.split(';').forEach((cookie) => {
    const cookieName = cookie.split('=')[0].trim()
    if (GA_PREFIXES.some((prefix) => cookieName.startsWith(prefix))) {
      document.cookie = `${cookieName}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${getDomain()}; Secure`
    }
  })
}
export const setThirdPartyCookie = () => {
  document.cookie = `third_party=enabled; Path=/; Expires=${date.toUTCString()}; domain=${getDomain()}; Secure`
}
export const unSetThirdPartyCookie = () => {
  document.cookie = `third_party=disabled; Path=/; Expires=${date.toUTCString()}; domain=${getDomain()}; Secure`
}
export const setBasicCookies = () => {
  document.cookie = `basic_cookie=enabled; Path=/; Expires=${date.toUTCString()}; domain=${getDomain()}; Secure`
}
